.collapse {
  /* stylelint-disable-next-line selector-max-compound-selectors */
  &:global(.ant-collapse .ant-collapse-item .ant-collapse-header .ant-collapse-arrow) {
    margin-right: 0;
    color: var(--rc-theme-color-text-default);
    font-size: var(--rc-theme-font-size-text-lg);
  }
}
